// Port of api/fuel/app/classes/filter/package/games/play/data/games/context.php
import Plays from 'offline/filter/plays'

function needsContext(filter) {
	return !!(
		(filter.played && filter.played.range && (filter.played.range.from || filter.played.range.to)) ||
		(filter.play && filter.play.count && (filter.play.count.from !== 1 || filter.play.count.to !== 10)) ||
		(filter.play && filter.play.duration && (filter.play.duration.from !== 0 || filter.play.duration.to !== 360)) ||
		(filter.play && filter.play.locations && filter.play.locations.length) ||
		(filter.play && filter.play.nolocation) ||
		(filter.play && filter.play.players && filter.play.players.required && filter.play.players.required.length)
	)
}

export default {
	priority: 10000,
	require: function(config, filter) { return filter.play && filter.play.group },
	run: function(filter, data, config, global) {
		if (!needsContext(filter)) return global

		var playContextIndex = Plays.forge({
			owner: config.owner,
			sessionID: config.sessionID,
			settings: config.settings,
			can: config.can,
			asIndex: true,
			filter: {
				played: {
					range: filter.played ? filter.played.range : { from: false, to: false }
				},
				play: {
					count: filter.play ? filter.play.count : { from: 1, to: 10 },
					duration: filter.play ? filter.play.duration : { from: 0, to: 360 },
					locations: filter.play ? filter.play.locations : [],
					nolocation: filter.play ? filter.play.nolocation : 0,
					players: filter.play ? filter.play.players : { required: [], together: 0 }
				},
				games: {
					subset: global.resultIndex || []
				}
			}
		}).run()

		global.playContextIndex = playContextIndex && playContextIndex.length ? playContextIndex : [0]
		return global
	}
}
